function initialState() {
  return {
    hasFinanceData: null,
    financeData: null,

    invoiceSettings: {
      accountKey: "",
      referenceNumber: "",
      mount: "",
      cpmRate: "",
      brdEmail: "",
      accountName: "",
    },

    financePeriod: {
      from: "",
      to: "",
    },

    financeFrequency: "daily",
  }
}

let state = initialState()

export { initialState, state }
